import 'regenerator-runtime'
import { createMetaManager } from 'vue-meta'
import { plugin as vueMetaPlugin } from 'vue-meta'

import { createApp } from 'vue'

import { createPinia } from 'pinia'

import App from '@/App.vue'
//import './registerServiceWorker';
import router from '@/router'
//import VueGtag from 'vue-gtag-next';

import { autoregisterBaseComponents } from './utils/components'

import Vueform from '@vueform/vueform'
import vueformConfig from './../vueform.config'

const pinia = createPinia()
const app = createApp(App)

autoregisterBaseComponents(app)

app.config.performance = true

// app.use(VueGtag, {
// 	property: {
// 		id: 'G-PWH7XRN8SK',
// 		anonymizeIp: true
// 	}
// });

app.use(pinia)
app.use(router)

app.use(Vueform, vueformConfig)

app.use(vueMetaPlugin)
app.use(createMetaManager())

app.mount('#app')
